import { MetaSearchInterface } from '../shared/interfaces/MetaSearchInterface';
import { useState, useEffect, useMemo, useContext } from 'react';
import GlobalContext from '../contexts/globalContext';
import { TabsEnum } from '../enums/enums';

const useMetaSearch = (
    meta:
        | 'comfama'
        | 'preguntas'
        | 'biblioteca'
        | 'autores'
        | 'redamor' = 'comfama'
) => {
    const [metaSearch, setMetaSearch] = useState<MetaSearchInterface[] | null>(
        null
    );
    const [filterSearch, setFilterSearch] = useState<
        MetaSearchInterface[] | null
    >(null);

    const [filterPage, setFilterPage] = useState<MetaSearchInterface[]>([]);
    const [paginator, setPaginator] = useState<number>(-1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [lastSearch, setLastSearch] = useState<string | null>(null);
    const [order, setOrder] = useState<'ASC' | 'DESC'>('ASC');
    const { selectedTab } = useContext(GlobalContext);

    const jsonSearch = () => {
        const hostname =
            window.location.hostname === 'localhost'
                ? '/'
                : '/portal-servicios/';
        if (selectedTab?.get === TabsEnum.BUSINESS) {
            return `${hostname}metas-mf/meta-contentful-Empresa.json`;
        }
        return `${hostname}metas-mf/meta-contentful-Persona.json`;
    };

    useEffect(() => {
        if (!metaSearch) {
            const _get = fetch(jsonSearch());

            _get.then(async (resp) => {
                const metadata = await resp.json();
                setMetaSearch(metadata);
            });
        }
        doFilter(lastSearch!);
    }, [lastSearch, limit, order, metaSearch]);

    const doFilter = (search: string) => {
        if (!metaSearch || !search || search.length < 4) {
            setFilterSearch(null);
            setFilterPage([]);
            setPaginator(-1);
            setTotalPages(0);
        } else {
            const filter = metaSearch
                .filter(
                    (meta) =>
                        meta.indexSearch.indexOf(search.toLowerCase()) > -1
                )
                .sort(fSort[order]);
            const nPages = filter.length / limit;
            setFilterSearch(filter);
            setTotalPages(
                nPages - Math.floor(nPages) !== 0 ? Math.ceil(nPages) : nPages
            );
            setFilterPage(filter.slice(0, limit));
            setPaginator(0);
            //   console.log("doFilter", "else-end")
        }
    };

    const fSort = {
        ASC: (a: MetaSearchInterface, b: MetaSearchInterface) =>
            a.fecha < b.fecha ? 1 : -1,
        DESC: (a: MetaSearchInterface, b: MetaSearchInterface) =>
            a.fecha > b.fecha ? 1 : -1,
    };

    useMemo(() => {
        if (paginator >= 0) {
            const slice = paginator * limit;
            if (filterSearch)
                setFilterPage(filterSearch.slice(slice, slice + limit));
        }
    }, [paginator]);

    const goNext = () => {
        goToPage(paginator + 1);
    };

    const goBack = () => {
        goToPage(paginator - 1);
    };

    const goToPage = (value: number) => {
        setPaginator(value);
    };

    const doSearch = (value: string) => {
        if (value !== lastSearch) {
            setLastSearch(value);
        }
    };

    return {
        metaSearch,
        filterSearch,
        filterPage,
        paginator,
        totalPages,
        goNext,
        goBack,
        goToPage,
        setLimit,
        doSearch,
        setOrder,
        order,
    };
};

export default useMetaSearch;
